'use client';

import { useAccountInfo } from '@/hooks/query/account';
import { useAuthToken } from '@/store/auth';
import clsx from 'clsx';
import { Breakpoint } from '../breakpoint';
import { useFloatBetslip } from '../betslip/hook/use-float-betslip';
import { useBreakpoint } from '../breakpoint/contexts';
import { SetShowPromotionStreamer } from '../promotion';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { PromotionChatroom } from '../promotion/promotion-chatroom';
import { FetchClearDomain } from '@/hooks/query/use-promotion-apibakend-tournament';
import { promotionAsideStyle } from './promotion-aside.style';
import { BetsPanel } from '../sportsbook-aside/components/bets-panel';

// promotion頁面顯示於Aside
export const PromotionAsie = () => {
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const authToken = useAuthToken();
	const ShowPromotionStreamerSrc = SetShowPromotionStreamer();
	const { breakpoint } = useBreakpoint();
	const { activeFloatBetSlip } = useFloatBetslip();

	if (user?.IsShouldClearDomain) {
		FetchClearDomain(user.ApiBackendUrl, user.AccessToken ?? '', user.ID.toString());
	}

	const showBetsPanel = authToken && user?.ActStatus === 2 && breakpoint > Breakpoint.lg && !activeFloatBetSlip;
	const isShowPromotionChatroom = SiteConfigsData?.EnableChatroom && user?.ActStatus == 2 && ShowPromotionStreamerSrc.length > 0 && user.RewardInfo.EnableRewardSystem

	return (
		<>
			{isShowPromotionChatroom || showBetsPanel ? (
				<div className={clsx('scrollbar', promotionAsideStyle.promotionAside)}>
					{ isShowPromotionChatroom && <PromotionChatroom StreamerSrc={ShowPromotionStreamerSrc} />}
					{ showBetsPanel ? <BetsPanel /> : null}  
				</div>
			): null}
		</>
	)
}